import Vue from 'vue';
import VueBreadcrumbs from 'vue-2-breadcrumbs';
import Breadcrumbs from '../components/Breadcrumbs.vue';

Vue.use(VueBreadcrumbs, Breadcrumbs);
